import {sectionDataAdapter} from "./sectionDataAdapter";

export const sectionSearchBotAdapter = (data: any) => {
  return {
    sectionData: sectionDataAdapter(data),
  }
}
